import { gql } from 'urql';
import { PRODUCT } from '../client';
import { ROUTE_FRAGMENT } from './fragments';

export const MARK_ROUTE_FOR_PROVIDER = gql`
  ${ROUTE_FRAGMENT}
  mutation ${PRODUCT}MarkRouteForProvider($input: MarkRouteForProviderInput!) {
    markRouteForProvider(input: $input) {
      route {
        ...RouteFragment
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
